export default {"src":"/_next/static/media/cart-filled.4aa11106.svg","height":20,"width":25,"blurWidth":0,"blurHeight":0};